import apiCall from "../../utils/apiCall";
import {apiUrls} from "../../constants/apiUrls";
import {CreateCounterparty, UpdateCounterparty} from "../../types/api/guide/counterparty.types";

export const counterpartyService = {
    getAll: () =>
        apiCall.get(apiUrls.guide.counterparty.getAll),

    create: (counterparty: CreateCounterparty) =>
        apiCall.post(apiUrls.guide.counterparty.create, counterparty),

    update: (id: string, counterparty: UpdateCounterparty) =>
        apiCall.put(apiUrls.guide.counterparty.update(id), counterparty),

    delete: (id: string) =>
        apiCall.delete(apiUrls.guide.counterparty.delete(id)),

    getById: (id: string) =>
        apiCall.get(apiUrls.guide.counterparty.getById(id))
}